import script from "./ProductNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ProductNavigation.vue?vue&type=style&index=0&id=0a28b36e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a28b36e"]])

export default __exports__